import { motion } from 'framer-motion'
import Lottie from 'react-lottie'
import LoadingAnimation from '../../assets/animations/98288-loading.json'
import Empty from './Empty'

const Loading: React.FC<LoadingProps> = ({ delay = 0.5 }) => {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0 },
        show: {
          opacity: 1,
          position: 'fixed',
          zIndex: 1,
          width: '86%',
          top: '45%',
          left: '12%',
          backgroundColor: 'transparent',
          transition: {
            delayChildren: delay,
          },
        },
      }}
      initial="hidden"
      animate="show"
    >
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          show: { opacity: 1 },
        }}
      >
        {/* <Lottie
          width={200}
          height={200}
          options={{
            loop: true,
            autoplay: true,
            animationData: LoadingAnimation,
            rendererSettings: { className: 'cursor-default' },
          }}
        // style={{ position: 'fixed', zIndex: 1, width: '86%', top: '45%' }}
        // style={{position: 'absolute', zIndex: 1, width: '86%', top: `${ (tableRef.current?.offsetHeight || 100)*0.8}px` }} //LUIS WAS HERE
        /> */}

        <Empty
          isFromLoading={true}
          animationProps={{
            height: 200,
            width: 200,
            animation: LoadingAnimation,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        ></Empty>
      </motion.div>
    </motion.div>
  )
}

export default Loading

interface LoadingProps {
  delay?: number
}
